/**
 * Thèmes Dark et Light pour Master Ski Pilou CRM
 * Utilise la nouvelle structure de globalTheme.js
 */

import globalTheme from './globalTheme';

// Light theme - utilise directement globalTheme qui est maintenant un thème light moderne
export const lightTheme = {
  ...globalTheme,

  // Ajout de propriétés compatibles avec l'ancien système pour la transition
  bgCard: globalTheme.colors.bgPrimary,
  bgHover: globalTheme.colors.bgHover,
  bgActive: globalTheme.colors.primaryLight,

  textInverse: '#ffffff',

  borderPrimary: globalTheme.colors.border,
  borderSecondary: globalTheme.colors.borderLight,
  borderLight: globalTheme.colors.borderLight,

  shadowSm: globalTheme.effects.shadowSm,
  shadowMd: globalTheme.effects.shadowMd,
  shadowLg: globalTheme.effects.shadowLg,

  sidebarText: globalTheme.colors.textLight,

  tableBg: globalTheme.colors.bgPrimary,
  tableHeaderBg: globalTheme.colors.bgSecondary,
  tableRowHover: globalTheme.colors.bgHover,
  tableRowEven: globalTheme.colors.bgSecondary,

  tagSeabob: globalTheme.colors.warning,
  tagBateaux: globalTheme.colors.primary,

  statusPending: globalTheme.colors.warning,
  statusConfirmed: globalTheme.colors.success,
  statusCancelled: globalTheme.colors.error,
  statusPaid: globalTheme.colors.info,

  // Ant Design token
  token: {
    colorPrimary: globalTheme.colors.primary,
    colorBgContainer: globalTheme.colors.bgPrimary,
    colorText: globalTheme.colors.textPrimary,
    colorTextSecondary: globalTheme.colors.textSecondary,
    colorBorder: globalTheme.colors.border,
    colorBorderSecondary: globalTheme.colors.borderLight,
    borderRadius: 12,
    fontSize: 14,
  }
};

// Dark theme - pour le moment, on garde le light theme car l'app est en light mode fixe
// TODO: Créer un vrai dark theme quand nécessaire
export const darkTheme = lightTheme;

// Utility function to get theme
export const getTheme = (isDark) => isDark ? darkTheme : lightTheme;
